import { render, staticRenderFns } from "./DefHandleList.vue?vue&type=template&id=9f219130&scoped=true&"
import script from "./DefHandleList.vue?vue&type=script&lang=js&"
export * from "./DefHandleList.vue?vue&type=script&lang=js&"
import style0 from "./DefHandleList.vue?vue&type=style&index=0&id=9f219130&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f219130",
  null
  
)

export default component.exports